import { VipLoungeResponse } from '@/backend/vip/get-lounge/types';
import { VipData } from '@/backend/vip/get-vip/types';
import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';
import { VipLevelUp } from './types';

/* -------------------------------------------------------------------------- */

interface VipStore {
	vipData: VipData | null;
	vipLoungeData: VipLoungeResponse['data'] | null;
	vipLevelUpData: VipLevelUp[];
	actions: {
		setVipData: (data: VipData) => void;
		setVipLoungeData: (data: VipLoungeResponse['data']) => void;
		setVipLevelUpData: (data: VipLevelUp[]) => void;
	};
}

/* -------------------------------------------------------------------------- */

const initialState: Omit<VipStore, 'actions'> = {
	vipData: null,
	vipLoungeData: null,
	vipLevelUpData: [],

	// [
	// 	{
	// 		level: 3,
	// 		tierName: 'Owner',
	// 		propertyName: 'CONDO',
	// 		pointsRequired: '1000.00',
	// 		description:
	// 			'A cozy unit within a shared building, offering both community and convenience.',
	// 		imageUrl:
	// 			'https://cdn.otherworld.xyz/public/assets/vip/vip-properties/condo.webp',
	// 		bonuses: [
	// 			{
	// 				type: 'CASH_BONUS',
	// 				depositBonus: null,
	// 				cashBonus: {
	// 					fiatAmount: '2.000000000000000000',
	// 				},
	// 				freespinBonus: null,
	// 			},
	// 			{
	// 				type: 'FREESPIN_BONUS',
	// 				depositBonus: null,
	// 				cashBonus: null,
	// 				freespinBonus: {
	// 					quantity: 5,
	// 				},
	// 			},
	// 		],
	// 	},
	// 	{
	// 		level: 6,
	// 		tierName: 'Landlord',
	// 		propertyName: 'CONDO',
	// 		pointsRequired: '1000.00',
	// 		description:
	// 			'A cozy unit within a shared building, offering both community and convenience.',
	// 		imageUrl:
	// 			'https://cdn.otherworld.xyz/public/assets/vip/vip-properties/landmark.webp',
	// 		bonuses: [
	// 			{
	// 				type: 'CASH_BONUS',
	// 				depositBonus: null,
	// 				cashBonus: {
	// 					fiatAmount: '2.000000000000000000',
	// 				},
	// 				freespinBonus: null,
	// 			},
	// 			{
	// 				type: 'FREESPIN_BONUS',
	// 				depositBonus: null,
	// 				cashBonus: null,
	// 				freespinBonus: {
	// 					quantity: 5,
	// 				},
	// 			},
	// 			{
	// 				type: 'DEPOSIT_BONUS',
	// 				depositBonus: {
	// 					deposit_percentage: 25,
	// 				},
	// 				cashBonus: null,
	// 				freespinBonus: null,
	// 			},
	// 		],
	// 	},
	// ],
};

/* -------------------------------------------------------------------------- */

const vipStore = create<VipStore>((set) => ({
	...initialState,

	actions: {
		setVipData: (data: VipData) => {
			set((state) => ({
				...state,
				vipData: data,
			}));
		},
		setVipLoungeData: (data: VipLoungeResponse['data']) => {
			set((state) => ({
				...state,
				vipLoungeData: data,
			}));
		},
		setVipLevelUpData: (data: VipLevelUp[]) => {
			set((state) => ({
				...state,
				vipLevelUpData: data,
			}));
		},
	},
}));

/* -------------------------------------------------------------------------- */
/* ----------------------------- state selectors ---------------------------- */

export const useVipData = () => vipStore(useShallow((state) => state.vipData));
export const useVipLoungeData = () =>
	vipStore(useShallow((state) => state.vipLoungeData));
export const useVipLevelUpData = () =>
	vipStore(useShallow((state) => state.vipLevelUpData));

/* -------------------------------------------------------------------------- */

export const useVipActions = () => vipStore((state) => state.actions);
